import { render, staticRenderFns } from "./FmBadge.vue?vue&type=template&id=139c64a5&scoped=true&"
import script from "./FmBadge.vue?vue&type=script&lang=js&"
export * from "./FmBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139c64a5",
  null
  
)

export default component.exports